import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function SummaryCard({ summaryData = {} }) {
  const {
    active_loans = 0,
    overdue_loans = 0,
    cancelled_loans = 0,
    completed_loans = 0,
    total_products = 0
  } = summaryData;

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'success';
      case 'overdue':
        return 'error';
      case 'cancelled':
        return 'warning';
      case 'completed':
        return 'info';
      default:
        return 'default';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active':
        return <AccountBalanceWalletIcon />;
      case 'overdue':
        return <TrendingDownIcon />;
      case 'cancelled':
        return <CancelIcon />;
      case 'completed':
        return <CheckCircleIcon />;
      default:
        return <AttachMoneyIcon />;
    }
  };

  const summaryItems = [
    {
      label: 'Préstamos Activos',
      value: active_loans,
      status: 'active',
      color: 'success'
    },
    {
      label: 'Préstamos Vencidos',
      value: overdue_loans,
      status: 'overdue',
      color: 'error'
    },
    {
      label: 'Préstamos Cancelados',
      value: cancelled_loans,
      status: 'cancelled',
      color: 'warning'
    },
    {
      label: 'Préstamos Completados',
      value: completed_loans,
      status: 'completed',
      color: 'info'
    }
  ];

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography
          component="h2"
          variant="subtitle2"
          gutterBottom
          sx={{ fontWeight: '600', mb: 2 }}
        >
          Resumen de Préstamos
        </Typography>
        
        <Stack spacing={2}>
          {summaryItems.map((item, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {getStatusIcon(item.status)}
                <Typography variant="body2" color="text.secondary">
                  {item.label}
                </Typography>
              </Box>
              <Chip 
                label={item.value} 
                color={item.color}
                size="small"
                variant="outlined"
              />
            </Box>
          ))}
          
          <Box sx={{ 
            mt: 2, 
            pt: 2, 
            borderTop: '1px solid', 
            borderColor: 'divider',
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between' 
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AttachMoneyIcon />
              <Typography variant="body2" color="text.secondary">
                Productos Financieros
              </Typography>
            </Box>
            <Chip 
              label={total_products} 
              color="primary"
              size="small"
              variant="outlined"
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}
